<!--
 * @Date: 2020-08-26 16:39:31
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-14 15:23:24
 * @FilePath: \pc-mall\src\components\CopyRight.vue
-->
<template>
  <div class="footer">
    <footer class="footer-contant">
      <img class="bg" src="../assets/images/home/bottomfigure.png"/>
      <img class="left" src="../assets/images/home/header.png"/>
      <!-- <img class="right" src="../assets/images/home/body.png"/> -->
      <img class="logo" :src="logo" />
      <p class="copyright-text">陕公网安备 61011302000661号 丨 <a class="a-link" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">陕ICP备18020687号-1</a> 丨 Copyright © 2012-2014 BMY.COM.CN All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: ['logo'],
  created () {
    console.log(this.logo, 's')
  }
}
</script>

<style scoped>
.footer {
  z-index: 999;
  position: relative;
  margin-top: 50px;
  background: transparent;
}
.footer-contant {
  font-family: "SimSun";
  height: 90px;
  bottom: 0;
  line-height: 90px;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  background-color: #241008;
  position: fixed;
  bottom: 0;
  left: 0;
}
.bg {
  width: 100%;
  height: 90px;
}
.left {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 325px;
}
@media screen and (max-width: 1900px) {
    .left {
      display: none;
    }
}
.right {
  position: fixed;
  bottom: 0;
  right: 0;
}
.logo {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.copyright-text {
    position: absolute;
    bottom: 0;
    left: 50%;
    line-height: 36px;
    color: #FFFFFF;
    transform: translateX(-50%);
    width: 100%;
}
.a-link {
  color: #FFFFFF;
}
</style>
